/* eslint-disable */
// import libs
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import moment from 'moment';
import { DatePicker, Slider, Space } from 'antd';

// import custom components
import { updateSelectedTab } from 'state/reducers/patient/patientActions';
import { createRoute } from 'routes/patientRouteUtils';
import {
  DatePopover,
  SliderPopover,
  SearchPopover,
  ListPopover,
} from 'legacy/containers/Popovers';
import { updatedSelectedKardiaRxPatient } from '../../state/kardiaRxIdtf/KardiaRxIDTFEcgTableActions';

import CustomTableComponent from '../../components/Common/Table/CustomTableComponent';
import TableHeader from '../../components/Common/Table/TableHeader';

import AvatarNumberAndText from '../../components/Common/Table/CellRendererComponents/Avatar/AvatarNumberAndText';
import ConnectionStatus from '../../components/Common/Table/CellRendererComponents/ConnectionStatus';
import { RANGE } from '../../constsnts/mdnStableRange'
// constants & Utility
import { DATASOURCES, getDataSource } from 'state/services/utils';
import { PATIENT_FILE_TABS } from '../../pages/PatientFile/PatientFileUtils';
import { CONDITION_COMPARE_TYPE } from '../../components/Common/Table/Constants/Constants';
import {
  AlertBoldTextCell,
  AlertHighlightCell,
} from '../../components/Common/Table//Utilities/CellStyle';
// constants / utilities
import {
  getDateInDaysHoursMinuit,
  getFormattedDate,
} from '../../components/Common/Table/Utilities/DateUtilities';

// import css
import styles from './KardiaRxPatientResult.css';
import { DateRangeSharp } from '@material-ui/icons';

const FILTER_TYPES = {
  MDN: 'mdn',
  STABLE: 'stable',
  NAME_MRN: 'name_mrn',
  ORDERING_PROVIDER: 'orderingProvider',
  STUDY_TYPE: 'serviceType',
  STUDY_PERIOD: 'studyPeriod',
  LAST_RECEIVED: 'lastReceived',
  CONNECTION: 'connection',
};

// Options for Connection types
const CONNECTION_LIST = [
  { id: 'All', label: 'All' },
  { id: 'connected', label: 'Connected' },
  { id: 'Active', label: 'Active' },
  { id: 'Complete', label: 'Completed' },
  { id: 'Enrolled', label: 'Enrolled' },
  { id: 'Pending', label: 'Pending' }
  

];

const STUDY_TYPES = {
  event: 'Event',
  Holter: 'Holter',
  extHolter: 'Extended Holter'
};
class KardiaRxPatientResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchPlaceHolderText: null,
      selectedStatusId: 'All',
      filteredData: [],
      filterApplied: false,
      startDate: new Date(),
      endDate: new Date(),
      filters: {
        mdnFilter: {
          showMdnFilter: false,
          min: RANGE.MIN_VALUE,
          max: RANGE.MAX_VALUE,
          minValue: RANGE.MIN_VALUE,
          maxValue: RANGE.MAX_VALUE,
        },
        stableFilter: {
          showStableFilter: false,
          min: RANGE.MIN_VALUE,
          max: RANGE.MAX_VALUE,
          minValue: RANGE.MIN_VALUE,
          maxValue: RANGE.MAX_VALUE,
        },
        studyPeriodFilter: {
          showStudyFilter: false,
          min: 0,
          max: 30,
          minValue: 0,
          maxValue: 30,
        },
        showNameMrnFilter: false,
        showConnectionFilter: false,
        showStudyTypeFilter: false,
        showStudyPeriodFilter: false,
        showLastReceivedFilter: false,
        showOrderingProviderFilter: false,
      },
    };
  }

  // componentDidMount() {
  //   this.state.filteredData = this.getTableData();
  // }

  getTableData = () => {
    if (this.state.filterApplied && this.state.filteredData.length > 0) {
      return this.state.filteredData;
    } else {
      const { RX_PATIENTS_CONNECTION_LIST_STATE } = this.props;
      const { participants } =
        RX_PATIENTS_CONNECTION_LIST_STATE.patients &&
        RX_PATIENTS_CONNECTION_LIST_STATE.patients.data[0];
      return participants;
    }
  };

  getTableDataForStatus = () => {
    const { RX_PATIENTS_CONNECTION_LIST_STATE } = this.props;
    const { participants } =
      RX_PATIENTS_CONNECTION_LIST_STATE.patients &&
      RX_PATIENTS_CONNECTION_LIST_STATE.patients.data[0];
    return participants;
  };

  // get the Table config fot column / row / filters
  getTableColumn = () => {
    const { me } = this.props;
    return [
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="MDN"
              keyMap="totalMdnEcg"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() => this.filterChange(FILTER_TYPES.MDN)}
              filterPopOverComponent={
                <Space direction="vertical">
                  <SliderPopover
                    label="Select MDN Range"
                    min={this.state.filters.mdnFilter.min}
                    max={this.state.filters.mdnFilter.max}
                    minValue={this.state.filters.mdnFilter.minValue}
                    maxValue={this.state.filters.mdnFilter.maxValue}
                    handleOnChange={e =>
                      this.handleOnSliderChange(e, FILTER_TYPES.MDN)
                    }
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                  />
                </Space>
              }
              showFilter={this.state.filters.mdnFilter.showMdnFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'totalMdnEcg',
        key: 'totalMdnEcg',
        width: 100,
        sorter: (a, b) => a.totalMdnEcg - b.totalMdnEcg,
        onCell: (record, rowIndex) => {
          const highlight = AlertHighlightCell(
            record.totalMdnEcg,
            CONDITION_COMPARE_TYPE.GREATER,
            0,
          );
          return { style: { ...highlight }, };
        },
        render: (text, record, index) => {
          return (
            <div>
              <AvatarNumberAndText
                type="number"
                data={text}
                size="medium"
                shape="square"
                color="brick"
              />
            </div>
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="STABLE"
              keyMap="totalStableEcg"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() => this.filterChange(FILTER_TYPES.STABLE)}
              filterPopOverComponent={
                <Space direction="vertical">
                  <SliderPopover
                    label="Select Stable Range"
                    min={this.state.filters.stableFilter.min}
                    max={this.state.filters.stableFilter.max}
                    minValue={this.state.filters.stableFilter.minValue}
                    maxValue={this.state.filters.stableFilter.maxValue}
                    handleOnChange={e =>
                      this.handleOnSliderChange(e, FILTER_TYPES.STABLE)
                    }
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                  />
                </Space>
              }
              showFilter={this.state.filters.stableFilter.showStableFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'totalStableEcg',
        key: 'totalStableEcg',
        width: 100,
        sorter: (a, b) => a.totalStableEcg - b.totalStableEcg,
        onCell: (record, rowIndex) => {
          const highlight = AlertHighlightCell(
            record.totalMdnEcg,
            CONDITION_COMPARE_TYPE.GREATER,
            0,
          );
          return {
            style: { ...highlight },
          };
        },
        render: (text, record, index) => {
          return (
            <AvatarNumberAndText
              type="number"
              data={text}
              size="medium"
              shape="circle"
              color="lightBlue"
            />
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="NAME & MRN"
              keyMap="patientFirstName"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() => this.filterChange(FILTER_TYPES.NAME_MRN)}
              filterPopOverComponent={
                <Space direction="vertical">
                  <Space direction="vertical">
                    <SearchPopover
                      handleOnChange={e =>
                        this.handleOnChange(e, FILTER_TYPES.NAME_MRN)
                      }
                      handleOnOutsidePopoverClick={() =>
                        this.handleOnOutsidePopoverClick()
                      }
                      placeholder="Name or Mrn..."
                      value={this.state.searchPlaceHolderText}
                    />
                  </Space>
                </Space>
              }
              showFilter={this.state.filters.showNameMrnFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'patientFirstName',
        key: 'patientFirstName',
        width: 180,
        sorter: (a, b) =>
          a.patientFirstName &&
          a.patientFirstName.localeCompare(b.patientFirstName),
        onCell: (record, rowIndex) => {
          const highlight = AlertHighlightCell(
            record.totalMdnEcg,
            CONDITION_COMPARE_TYPE.GREATER,
            0,
          );
          return {
            style: { ...highlight },
          };
        },
        render: (text, record, index) => {
          const boldText = AlertBoldTextCell(
            record.isViewed,
            CONDITION_COMPARE_TYPE.EQUAL,
            false,
          );
          const name = `${record.patientLastName} , ${record.patientFirstName}`;
          return (
            <div
              style={{
                fontWeight: boldText === true ? 'bold' : 'normal',
              }}
            >
              <p>
                {name}
              </p>
              <p>
                {record.mrn}
              </p>
            </div>
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="CONNECTION"
              keyMap="status"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() => this.filterChange(FILTER_TYPES.CONNECTION)}
              filterPopOverComponent={
                <Space direction="vertical">
                  {/* <SearchPopover
                    handleOnChange={e =>
                      this.handleOnChange(e, FILTER_TYPES.CONNECTION)
                    }
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                    placeholder="Connection Status..."
                  /> */}
                  <ListPopover
                    list={CONNECTION_LIST}
                    selected={this.state.selectedStatusId}
                    getOptionLabel={d => d.label}
                    getOptionValue={d => d.id}
                    handleOnClick={e =>
                      this.handleListChange(e)
                    }
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                  />
                </Space>
              }
              showFilter={this.state.filters.showConnectionFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'status',
        key: 'status',
        width: 140,
        sorter: (a, b) => a.status && a.status.localeCompare(b.status),
        onCell: (record, rowIndex) => {
          const highlight = AlertHighlightCell(
            record.totalMdnEcg,
            CONDITION_COMPARE_TYPE.GREATER,
            0,
          );
          return { style: { ...highlight }, };
        },
        render: (text, record, index) => {
          return <ConnectionStatus status={text} />;
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="STUDY TYPE"
              keyMap="serviceType"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() => this.filterChange(FILTER_TYPES.STUDY_TYPE)}
              filterPopOverComponent={
                <Space direction="vertical">
                  <SearchPopover
                    handleOnChange={e =>
                      this.handleOnChange(e, FILTER_TYPES.STUDY_TYPE)
                    }
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                    placeholder="Study type..."
                  />
                </Space>
              }
              showFilter={this.state.filters.showStudyTypeFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'serviceType',
        key: 'serviceType',
        width: 150,
        sorter: (a, b) => a.serviceType && a.serviceType.localeCompare(b.serviceType),
        onCell: (record, rowIndex) => {
          const highlight = AlertHighlightCell(
            record.totalMdnEcg,
            CONDITION_COMPARE_TYPE.GREATER,
            0,
          );
          return { style: { ...highlight }, };
        },
        render: (text, record, index) => {
          const boldText = AlertBoldTextCell(
            record.isViewed,
            CONDITION_COMPARE_TYPE.EQUAL,
            false,
          );
          const data = record.serviceType && STUDY_TYPES[record.serviceType];
          return (
            <p style={{ fontWeight: boldText === true ? 'bold' : 'normal', }}            >
              {data}
            </p >
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="STUDY PERIOD"
              keyMap="studyPeriodStartsAt"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() =>
                this.filterChange(FILTER_TYPES.STUDY_PERIOD)
              }
              filterPopOverComponent={
                <Space direction="vertical">
                  <SliderPopover
                    label="Select Day Range"
                    min={this.state.filters.studyPeriodFilter.min}
                    max={this.state.filters.studyPeriodFilter.max}
                    minValue={this.state.filters.studyPeriodFilter.minValue}
                    maxValue={this.state.filters.studyPeriodFilter.maxValue}
                    handleOnChange={e =>
                      this.handleOnSliderChange(e, FILTER_TYPES.STUDY_PERIOD)
                    }
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                  />
                </Space>
              }
              showFilter={
                this.state.filters.studyPeriodFilter.showStudyPeriodFilter
              }
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'studyPeriodStartsAt',
        key: 'studyPeriodStartsAt',
        width: 140,
        sorter: (a, b) => {
          const dateA = new Date(a.studyPeriodStartsAt);
          const dateB = new Date(b.studyPeriodStartsAt);
          return dateA - dateB;
        },
        onCell: (record, rowIndex) => {
          const highlight = AlertHighlightCell(
            record.totalMdnEcg,
            CONDITION_COMPARE_TYPE.GREATER,
            0,
          );
          return {
            style: { ...highlight },
          };
        },
        render: (text, record, index) => {
          const boldText = AlertBoldTextCell(
            record.isViewed,
            CONDITION_COMPARE_TYPE.EQUAL,
            false,
          );
          return (
            <p
              style={{
                fontWeight: boldText === true ? 'bold' : 'normal',
              }}
            >
              {
                record.status == ('Complete' || 'Completed') ?
                <p>
                  Completed
                </p> :
                text !== null &&
                  moment(new Date()).isAfter(record.studyPeriodEndsAt) != true
                  ? <React.Fragment>
  
                    {record.studyDurationInDays !== null &&
                      <p>
                        {record.studyDurationInDays} Days
                      </p>
                    }
                    <p>
                      (Day {moment(new Date()).diff(moment(text), 'days')})
                    </p>
                  </React.Fragment>
                  : '--'
              }
            </p>
          );
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="LAST RECEIVED"
              keyMap="latestEcgRecordedAt"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() =>
                this.filterChange(FILTER_TYPES.LAST_RECEIVED)
              }
              filterPopOverComponent={
                <Space direction="vertical">
                  <DatePopover
                    handleOnChange={e => this.handleOnDateFilterChange(e)}
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                    // min={new Date()}
                    // max={new Date()}
                    startDate={this.state.startDate}
                    endDate={this.state.endDate}
                  />
                </Space>
              }
              showFilter={this.state.filters.showLastReceivedFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'latestEcgRecordedAt',
        key: 'latestEcgRecordedAt',
        sorter: (a, b) => {
          const dateA = new Date(a.latestEcgRecordedAt);
          const dateB = new Date(b.latestEcgRecordedAt);
          return dateA - dateB;
        },
        onCell: (record, rowIndex) => {
          const highlight = AlertHighlightCell(
            record.totalMdnEcg,
            CONDITION_COMPARE_TYPE.GREATER,
            0,
          );
          return {
            style: { ...highlight },
          };
        },
        render: (text, record, index) => {
          const boldText = AlertBoldTextCell(
            record.isViewed,
            CONDITION_COMPARE_TYPE.EQUAL,
            false,
          );
          if (text !== undefined && text !== null) {
            const dateObj = getDateInDaysHoursMinuit(null, text);
            // const dateFormatted = getFormattedDate(text, me); // not in use
            return (
              <p
                style={{
                  fontWeight: boldText === true ? 'bold' : 'normal',
                }}
              >
                {dateObj.days} {dateObj.days > 1 ? "days," : "day,"} {dateObj.hours} hrs ago
                {/* {'\n'}
                {dateFormatted} */}
              </p>
            );
          }
          return '-';
        },
      },
      {
        title: ({ sortOrder, sortColumn, filters }) => {
          return (
            <TableHeader
              headerTxt="ORDERING PROVIDER"
              keyMap="orderingProviderFirstName"
              enableFilterRow={true}
              enableFilter={true}
              filterFunction={() =>
                this.filterChange(FILTER_TYPES.ORDERING_PROVIDER)
              }
              filterPopOverComponent={
                <Space direction="vertical">
                  <SearchPopover
                    handleOnChange={e =>
                      this.handleOnChange(e, FILTER_TYPES.ORDERING_PROVIDER)
                    }
                    handleOnOutsidePopoverClick={() =>
                      this.handleOnOutsidePopoverClick()
                    }
                    placeholder="Ordering Provider Name..."
                  />
                </Space>
              }
              showFilter={this.state.filters.showOrderingProviderFilter}
              sortOrder={sortOrder}
              sortColumn={sortColumn}
            />
          );
        },
        dataIndex: 'orderingProviderFirstName',
        key: 'orderingProviderFirstName',
        sorter: (a, b) =>
          a.orderingProviderFirstName &&
          a.orderingProviderFirstName.localeCompare(
            b.orderingProviderFirstName,
          ),
        onCell: (record, rowIndex) => {
          const highlight = AlertHighlightCell(
            record.totalMdnEcg,
            CONDITION_COMPARE_TYPE.GREATER,
            0,
          );
          return {
            style: { ...highlight },
          };
        },
        render: (text, record, index) => {
          const boldText = AlertBoldTextCell(
            record.isViewed,
            CONDITION_COMPARE_TYPE.EQUAL,
            false,
          );
          const data =
            record.orderingProviderFirstName != null
              ? `Dr. ${record.orderingProviderFirstName} , ${record.orderingProviderLastName}`
              : '';
          return (
            <p
              style={{
                fontWeight: boldText === true ? 'bold' : 'normal',
              }}
            >
              {data}
            </p>
          );
        },
      },
    ];
  };

  // Row clicked
  clickedRow = (rowData, index) => {
    const { dispatch, history, updatePatientState, updateTab } = this.props;
    updatePatientState(rowData);
    updateTab(PATIENT_FILE_TABS.KARDIA_RX);
    history.push(
      createRoute({
        patientId: rowData.participantId,
        kardiaRxEcg: 'patientSearch',
        idtf_connection_id: rowData.id,
      }),
    );
  };

  handleOnOutsidePopoverClick = () => {
    this.setState({
      ...this.state,
      filters: {
        mdnFilter: { ...this.state.filters.mdnFilter, showMdnFilter: false },
        stableFilter: {
          ...this.state.filters.stableFilter,
          showStableFilter: false,
        },
        showNameMrnFilter: false,
        studyPeriodFilter: {
          ...this.state.filters.studyPeriodFilter,
          showStudyPeriodFilter: false,
        },
        showOrderingProviderFilter: false,
        showConnectionFilter: false,
        showStudyFilter: false,
        showLastReceivedFilter: false,
      },
    });
  };

  // change the state of filter show
  filterChange = filterType => {
    let filterValue = this.state.filters;
    switch (filterType) {
      case FILTER_TYPES.MDN:
        filterValue.mdnFilter.showMdnFilter = true;
        break;
      case FILTER_TYPES.STABLE:
        filterValue.stableFilter.showStableFilter = true;
        break;
      case FILTER_TYPES.NAME_MRN:
        filterValue.showNameMrnFilter = true;
        break;
      case FILTER_TYPES.CONNECTION:
        filterValue.showConnectionFilter = true;
        break;
      case FILTER_TYPES.STUDY_TYPE:
        filterValue.showStudyTypeFilter = true;
        break;
      case FILTER_TYPES.STUDY_PERIOD:
        filterValue.studyPeriodFilter.showStudyPeriodFilter = true;
        break;
      case FILTER_TYPES.LAST_RECEIVED:
        filterValue.showLastReceivedFilter = true;
        break;
      case FILTER_TYPES.ORDERING_PROVIDER:
        filterValue.showOrderingProviderFilter = true;
        break;
      default:
        break;
    }
    this.setState({
      filters: {
        ...filterValue,
      },
    });
  };

  handleOnDateFilterChange = e => {
    let filteredEvents = [];
    this.setState({
      startDate: e.startDate,
      endDate: e.endDate,
    });
    filteredEvents = this.getTableData().filter(item => {
      return (
        new Date(item.latestEcgRecordedAt) >= e.startDate &&
        new Date(item.latestEcgRecordedAt) <= e.endDate
      );
    });
    this.setState({ filterApplied: true, filteredData: filteredEvents });
  };

  handleOnChange = (e, filterType) => {
    let filteredEvents = [];
    const searchText = e.toLowerCase();
    if (searchText == '') {
      this.setState({ ...this.state, filterApplied: false, searchPlaceHolderText: searchText });
    } else {
      switch (filterType) {
        case FILTER_TYPES.NAME_MRN:
          filteredEvents = this.getTableData().filter(item => {
            let data = `${item.patientLastName} , ${item.patientFirstName} ${item.mrn}`;
            data = data.toLowerCase();
            return data.includes(searchText);
          });
          break;
        case FILTER_TYPES.CONNECTION:
          filteredEvents = this.getTableData().filter(item => {
            // item.status = item.status.toLowerCase();
            return item.status.toLowerCase().includes(searchText);
          });
          break;
        case FILTER_TYPES.STUDY_TYPE:
          filteredEvents = this.getTableData().filter(item => {
            console.log('item', item);
            item.serviceType = item.serviceType && item.serviceType.toLowerCase();
            return item.serviceType && item.serviceType.includes(searchText);
          });
          break;
        case FILTER_TYPES.LAST_RECEIVED:
          this.setState({
            startDate: e.startDate,
            endDate: e.endDate,
          });
          filteredEvents = this.getTableData().filter(item => {
            return (
              new Date(item.latestEcgRecordedAt) >= e.startDate &&
              new Date(item.latestEcgRecordedAt) <= e.endDate
            );
          });

          break;
        case FILTER_TYPES.ORDERING_PROVIDER:
          filteredEvents = this.getTableData().filter(item => {
            let name = `${item.orderingProviderFirstName} , ${item.orderingProviderFirstName}`;
            name = name.toLowerCase();
            return name.includes(searchText);
          });
          break;
        default:
          break;
      }
      // console.log('filteredEvents', filteredEvents);
      this.setState({ ...this.state, filterApplied: true, filteredData: filteredEvents, searchPlaceHolderText: searchText, selectedStatusId: 'All' });
    }
  };

  handleListChange = (e) => {
    let filteredEvents = [];
    if(e=== 'All') {
      filteredEvents = this.getTableDataForStatus()
    }
    else {
    if (this.state.filters.showConnectionFilter) {
      filteredEvents = this.getTableDataForStatus().filter(item => {
        return item.status.includes(e);
      });
    } else {
      filteredEvents = this.getTableData().filter(item => {
        return item.status.includes(e);
      });
    }}
    this.setState({ ...this.state, filterApplied: true, filteredData: filteredEvents, selectedStatusId: e, searchPlaceHolderText: null });
  }

  handleOnSliderChange = (e, filterType) => {
    let filteredEvents = [];
    switch (filterType) {
      case FILTER_TYPES.MDN:
        this.setState({
          filters: {
            ...this.state.filters,
            mdnFilter: {
              ...this.state.filters.mdnFilter,
              minValue: e[0],
              maxValue: e[1],
            },
          },
        });
        filteredEvents = this.getTableData().filter(item => {
          return item.totalMdnEcg >= e[0] && item.totalMdnEcg <= e[1];
        });
        break;
      case FILTER_TYPES.STABLE:
        this.setState({
          filters: {
            ...this.state.filters,
            stableFilter: {
              ...this.state.filters.stableFilter,
              minValue: e[0],
              maxValue: e[1],
            },
          },
        });
        filteredEvents = this.getTableData().filter(item => {
          return item.totalStableEcg >= e[0] && item.totalStableEcg <= e[1];
        });
        break;
      case FILTER_TYPES.STUDY_PERIOD:
        this.setState({
          filters: {
            ...this.state.filters,
            studyPeriodFilter: {
              ...this.state.filters.studyPeriodFilter,
              minValue: e[0],
              maxValue: e[1],
            },
          },
        });
        filteredEvents = this.getTableData().filter(item => {
          return (
            moment(new Date()).diff(moment(item.studyPeriodStartsAt), 'days') >=
            e[0] &&
            moment(new Date()).diff(moment(item.studyPeriodStartsAt), 'days') <=
            e[1]
          );
        });
        break;
      case FILTER_TYPES.LAST_RECEIVED:
        // filteredEvents = this.getTableData().filter(item => {
        //   return (
        //     item.latestEcgRecordedAt >= e[0] && item.latestEcgRecordedAt <= e[1]
        //   );
        // });
        break;
      default:
        break;
    }
    this.setState({ filterApplied: true, filteredData: filteredEvents });
  };

  render() {
    const { me, RX_PATIENTS_CONNECTION_LIST_STATE } = this.props;
    return (
      <React.Fragment>
        {RX_PATIENTS_CONNECTION_LIST_STATE.patients.data.length && (
          <div className={styles.kardiaRxPatient}>
            <CustomTableComponent
              columns={this.getTableColumn()}
              data={
                this.state.filterApplied && this.state.filteredData
                  ? this.state.filteredData
                  : RX_PATIENTS_CONNECTION_LIST_STATE.patients &&
                  RX_PATIENTS_CONNECTION_LIST_STATE.patients.data[0] &&
                  RX_PATIENTS_CONNECTION_LIST_STATE.patients.data[0]
                    .participants
              }
              scrollHeight={{ y: 'calc(100vh - 20em)' }}
              clickedRow={this.clickedRow}
            />
          </div>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const me = getDataSource(state, DATASOURCES.ME);
  const RX_PATIENTS_CONNECTION_LIST_STATE = state.kardiaRx.kardiaRxIDTFPatients;
  // const { form, search } = state;
  return {
    me,
    RX_PATIENTS_CONNECTION_LIST_STATE,
  };
};

const mapActionCreators = {
  updatePatientState: updatedSelectedKardiaRxPatient,
  updateTab: updateSelectedTab,
};
export default connect(
  mapStateToProps,
  mapActionCreators,
)(injectIntl(KardiaRxPatientResult));



// WEBPACK FOOTER //
// ./src/views/containers/KardiaRxPatientResult/KardiaRxPatientResult.jsx